/** Normalise a parcel number as typed: trim, drop spaces, accept "243-1" for "243/1" (SPEC §4.1). */
export function normaliseParcelNo(s: string): string {
  return s.replace(/\s+/g, '').replace(/-/g, '/');
}
